app.mediator.registerModule(MODULE_NAME__REGISTER_FORM, function (app) {

    var dataStore = app.data;
    var helpers = app.helpers.funcs;

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The certificate document upload file input
        $fileInputElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        useGreCaptcha: false,
        grecaptchaLoaded: false,
        grecaptchaId: null,

        isDomLoaded: false,
        isCaptchaScriptLoaded: false,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
            if (data.hasJustLoaded(RESOURCE_NAME__GOOGLE_RECAPTCHA)) {
                this.useGreCaptcha = true;
                this.isCaptchaScriptLoaded = true;
            }
            if (!this.grecaptchaLoaded && this.isDomLoaded && this.isCaptchaScriptLoaded) {
                if ((!this.$formElem) || (!this.$formElem.length)) return;
                this.grecaptchaLoaded = true;
                this.grecaptchaId = app.helpers.funcs.protectFormInvisibleCaptcha(this.$formElem);
            }
        },

        init: function () {

            // Init
            var scope = this;

            // Prepare data for creation of jda validator instance
            var baseConstraints = dataStore.get('validation.registerForm');
            this.$formElem = $('#form-register');

            // Don't bother to add the event listeners if the form DOM element does not exist
            // i.e. We are on another page. This will save memory.
            if (!this.$formElem.length) return;

            // Create jda validator instance
            this.jdaValidator = app.validator.build({}, this.$formElem);

            // Add constraints data to validator
            this.jdaValidator.constraintBag.addConstraints(baseConstraints);

            this.$formElem.find('input[type=password], input[type=text], input[type=tel], textarea').keyup(function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;

                // Adjust this element's validation messages
                var $elem = $(this);
                var formFieldId = scope.jdaValidator.configuration.getFormFieldId($elem);
                scope.handleElemChange($elem);

                // Also do a little loop-back check on the confirm password field when we are changing the password field.
                if (formFieldId == 'passwordInput') {
                    $confirmPasswordElem = scope.$formElem.find('#confirmPasswordInput');
                    if ($confirmPasswordElem.val() && $elem.val()) {
                        scope.handleElemChange($confirmPasswordElem);
                    }
                }
            });
            this.$formElem.find('input[type=file]').on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function () {
                var $elem = $(this);
                scope.handleElemChange($elem);
            });
            this.$formElem.find('select, input[type=checkbox], input[type=radio]').change(function () {
                var $elem = $(this);
                scope.handleElemChange($elem);
            });
            this.$formElem.submit(function (e, options) {
                scope.handleFormSubmit(e, options);
            });

            // When the email address input changes, ask the server if it is valid.
            // If not, add the address to a list of invalid values, within the form constraints object.
            // Gate the AJAX call to once every 500ms.
            var emailCheckTimeout;
            var $emailElem = scope.$formElem.find('#emailAddressInput');
            var emailElemId = scope.jdaValidator.configuration.getFormFieldId($emailElem);
            $emailElem.on('change keyup', function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                var emailValue = $(this).val();
                clearTimeout(emailCheckTimeout);
                // if (!emailValue) return;
                emailCheckTimeout = setTimeout(function () {
                    scope.checkIfEmailExists(emailValue, function (exists) {
                        if (exists) {
                            var constraint = scope.jdaValidator.constraintBag.getConstraint(emailElemId, 'notInArray');
                            constraint.params.disallowedValues.push(emailValue);
                        }
                        scope.handleElemChange($emailElem, true);
                    });
                }, 500);
            });

            // Initialize the how you heard dropdown
            scope.$formElem.find('#howYouHeardSelect')
                .change(function () {
                    var dropdownValue = $(this).val();
                    if (dropdownValue === 'HowYouHeardOther') {
                        scope.$formElem.find("#howYouHeardInput").val("");
                        scope.$formElem.find("#howYouHeardFreeTextSection").removeClass("hidden");
                    } else {
                        scope.$formElem.find("#howYouHeardInput").val(dropdownValue);
                        scope.$formElem.find("#howYouHeardFreeTextSection").addClass("hidden");
                    }
                });

            // Init upload
            scope.initUploadInput();

            app.mediator.notify(EVENT_NAME__REGISTER_FORM__INITIATED);
        },

        //==========================================================xdiv2====
        // DOM event handlers
        //===================================================================

        handleFormSubmit: function (e, options) {
            var scope = this;
            options = options || {};

            if (!options.formChecked) {
                e.preventDefault();

                var documentIds = [];
                $("div.preview").each(function () {
                    var documentId = $(this).data("image-id");
                    if (documentId) {
                        documentIds.push(documentId);
                    }
                });

                helpers.validateDocuments(
                    documentIds,
                    function() {
                        scope.doSave(e);
                    },
                    EVENT_NAME__REGISTER_FORM__IMAGE_DOESNT_EXIST,
                    window.serverData.generalLanguageStrings.certificateNeedsReUploadingToastMessage);
            }
        },

        doSave: function (e, scope) {
            var grecaptchaVal = null;

            if (this.useGreCaptcha) {
                grecaptchaVal = this.$formElem.find('[name="g-recaptcha-response"]').val();
                if (!this.grecaptchaLoaded) {
                    e.preventDefault();
                    var fallbackError = 'Please wait for the page to load before submitting the form.';
                    var error = window.serverData.generalLanguageStrings.captchaNotReady || fallbackError;
                    app.ui.uiPlugins.toast.fire(error, 'danger');
                    return;
                }
            }

            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasMessages()) {
                this.jdaValidator.presenter.scrollToFirstError();
            }
            else {
                if (this.useGreCaptcha) {
                    if (grecaptchaVal) {
                        $(e.currentTarget).trigger('submit', { 'formChecked': true });
                    } else {
                        e.preventDefault();
                        app.ui.uiPlugins.toast.fire('Please complete the CAPTCHA before submitting this form.', 'danger');                  
                    }
                }
                else {
                    $(e.currentTarget).trigger('submit', { 'formChecked': true });
                }
            }
        },

        // NB We should not run validation checks on the fields that are validated via data obtained via AJAX.
        // (If we do, we may breifly get a 'Looks good' message which then quickly changes to 'Looks bad', which 
        // doesn't make for the best user experience.
        // When the AJAX validation does run, it will call this method with a second param of true, which indicates
        // that it is actually ok to run the validation checks, as all data is now immediately available.
        handleElemChange: function ($elem, forceValidationProcess) {
            forceValidationProcess = typeof forceValidationProcess !== 'null' ? forceValidationProcess : false;
            var elemId = this.jdaValidator.configuration.getFormFieldId($elem);
            if (elemId == 'emailAddressInput' && (!forceValidationProcess)) {
                return;
            }
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBag = this.jdaValidator.getMessageBagForFormField(formFieldId);
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBag);
        },
        
        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        // None yet

        //==========================================================xdiv2====
        // Module
        //===================================================================

        getEmailCheckUrl: function (emailValue) {
            var encodedEmail = encodeURIComponent(emailValue);
            var url = helpers.url('umbraco/api/EntrantApi/IsEmailAddressRegistered?emailAddress=' + encodedEmail);
            return url;
        },

        checkIfEmailExists: function (value, callback) {
            var checkUrl = this.getEmailCheckUrl(value);
            $.ajax({
                type: "GET",
                url: checkUrl,
                dataType: "json",
                success: function (response) {
                    if (typeof callback == 'function') {
                        callback(response.result);
                    }
                }
            });
        },

        initUploadInput: function () {
            var scope = this;
            this.$fileInputElem = this.$formElem.find('.jda-file-input-seed');
            var $inputAndDropWrapElem = this.$fileInputElem.closest('.feedback-group');
            var $dropAreaElem = $inputAndDropWrapElem.find('.file-drop-area');
            this.$fileInputElem.jdaUpload({
                $dropAreaElem: $dropAreaElem,
                uploadTargetUrl: helpers.url('/umbraco/api/DocumentApi/UploadRegistrationCertificate'),
                removeButtonText: this.$fileInputElem.data('removebuttontext'),
                alwaysUseClientSideThumb: true
            });

            this.$fileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function () {
                scope.doFileValidation(false);
            });
            this.$fileInputElem.on(EVENT_NAME__JDA_UPLOAD__FILES_SET, function (e, data) {
                scope.doFileValidation(data.files);
            });
        },

        doFileValidation: function(files) {
            var scope = this;
            var formFieldId = scope.jdaValidator.configuration.getFormFieldId(scope.$fileInputElem);
            if (typeof files !== 'undefined') {
                if (files === false) {
                    scope.jdaValidator.clearCachedValuesForFormField(formFieldId);
                } else {
                    scope.jdaValidator.cacheValuesForFormField(formFieldId, files);
                }
            }
            var messageBag = scope.jdaValidator.getMessageBagForFormField(formFieldId);
            scope.jdaValidator.presenter.clearStatus(scope.$fileInputElem);
            scope.jdaValidator.presenter.showStatus(scope.$fileInputElem, messageBag);
        }
    };
});
